import React from "react"
import {
  createStyles,
  styled,
  forwardRef,
  Styles,
  DesignTokens,
} from "@design-system/styled-system"
import { IconProps } from "./types"

export const Icon = forwardRef<IconProps, "svg">((props, ref) => {
  const { style, fill, color, ...rest } = props
  const fillColor = fill ? Styles.theme.iconColors[fill] || fill : undefined
  return (
    <styled.svg
      {...rest}
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      style={[styles.root, !fill && styles.fill, style]}
      ref={ref}
    />
  )
})

Icon.defaultProps = {
  width: 24,
  height: 24,
}

Icon.displayName = "Icon"

const styles = createStyles({
  root: {
    display: "inline-block",
    maxWidth: "100%",
    position: "relative",
    userSelect: "none",
    textAlignVertical: "text-bottom",
  },
  fill: {
    fill: "currentcolor",
  },
})
